import React from 'react';
import'../../App.css';
import About from '../About';
import ContactUs from '../ContactUs';
import Footer from '../Footer';
import HeroSection from '../HeroSection';
import Members from '../Members';

function Home(){
    return(
        <>
            <HeroSection />
            <About />
            <Members />
            <ContactUs />
            <Footer/>
        </>
    )
}
export default Home;